import { useEffect, useState } from 'react'
import { Form, Formik } from 'formik'
import * as S from './style'
import Fields from '@components/fields'

const ProviderDetails = ({ user }) => {
  const [initialValues, setInitialValues] = useState({
    image: '',
  })

  const profileData = [
    {
      label: 'Company Name',
      value: user?.infos?.companyInfos?.companyName || 'N/A',
    },
    {
      label: 'Company Contact',
      value: user?.infos?.companyInfos?.companyContactNumber || 'N/A',
    },
    {
      label: 'Company Address',
      value: user?.infos?.companyInfos?.companyAddress || 'N/A',
    },
  ]

  useEffect(() => {
    setInitialValues({
      image: user?.infos?.companyInfos?.businessDocument || '',
    })
  }, [user])

  const hasImage = Boolean(initialValues.image)

  return (
    <S.StyleMainContainer>
      {/* Left Side - Company Infos */}
      <S.LeftColumn>
        <S.InfosContainer>
          {profileData.map((d, i) => (
            <S.StyleProfileInfoWrapper key={i}>
              <S.StyleLabel>{d.label}</S.StyleLabel>
              <S.StyleTextContaienr>{d.value}</S.StyleTextContaienr>
            </S.StyleProfileInfoWrapper>
          ))}
        </S.InfosContainer>
      </S.LeftColumn>

      {/* Right Side - Upload Business Registration */}
      <S.RightColumn>
        <div style={{ position: 'relative' }}>
          <Formik
            initialValues={initialValues}
            onSubmit={() => {}}
            enableReinitialize
          >
            <Form>
              <Fields.Upload
                name="image"
                label="Business Registration"
                variant="banner"
                disabled={true}
              />
            </Form>
          </Formik>

          {/* Overlay if no image */}
          {!hasImage && (
            <S.NoImageOverlay>
              <span>No Image Available</span>
            </S.NoImageOverlay>
          )}
        </div>
      </S.RightColumn>
    </S.StyleMainContainer>
  )
}

export default ProviderDetails
